import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import logo from "../assets/splash logo.svg";

const PageNotFound = () => {
  const navigate = useNavigate();

  const handleLinkClick = () => {
    navigate('/');
    window.scrollTo(0, 0);
  };

  return (
    <div className="flex flex-col bg-white">
      <div className="fixed top-0 left-0 w-full bg-white shadow-md z-10 px-4 py-4 flex items-center">
        <Link onClick={handleLinkClick} to={'/'} className="flex items-center cursor-pointer">
          <img src={logo} alt="Swop Logo" className="w-[52.12px] h-[50px] lg:ml-[200px] sm:w-[40px] sm:h-[40px]" />
          <h1 className="uppercase text-spay-logo-text font-bold text-3xl sm:text-2xl ml-2">
            Swop
          </h1>
        </Link>
      </div>

      <div className="flex justify-center items-center lg:h-[900px] md:h-[600px] ms:h-[400px]">
        <div className="bg-white p-8 md:p-10 lg:p-12 rounded-lg shadow-md w-full md:w-3/4 lg:w-2/3 xl:w-1/2">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-800 mb-4">404 - Page Not Found</h1>
          <p className="text-lg md:text-xl lg:text-2xl text-gray-600">Sorry, the page you are looking for does not exist.</p>
        </div>
      </div>
    </div>
  );
}

export default PageNotFound;
